/**
 * Shared constants for FireTablet Feature Rotator configurations
 */

import { TabletDeviceType, TabletSize, TabletOrientation } from '../types';

// Common values
export const ALT_TEXT = 'Please upload both background image and logo to preview';
export const SHIFT_FACTOR = 0.85;
export const FONT_FAMILY = 'Amazon Ember';
export const TEXT_COLOR = '#FFFFFF';
export const MAX_LINES = 2;

// Gradient colors
export const GRADIENT_DARK = 'rgba(0, 0, 0, 0.8)';
export const GRADIENT_TRANSPARENT = 'rgba(0, 0, 0, 0)';

// Scrim colors
export const SCRIM_START = 'rgba(0, 0, 0, 0.2667)';
export const SCRIM_END = 'rgba(0, 0, 0, 0)';

/**
 * Device type to allowed sizes mapping
 */
export const DEVICE_TYPE_SIZE_MAP: Record<TabletDeviceType, TabletSize[]> = {
  [TabletDeviceType.FOS]: [
    TabletSize.SEVEN_INCH,
    TabletSize.EIGHT_INCH,
    TabletSize.TEN_INCH,
    TabletSize.ELEVEN_INCH,
  ],
  [TabletDeviceType.KH]: [TabletSize.EIGHT_INCH, TabletSize.ELEVEN_INCH, TabletSize.TWELVE_INCH],
};

/**
 * Default state per device type
 */
export const DEVICE_TYPE_DEFAULTS: Record<
  TabletDeviceType,
  { size: TabletSize; orientation: TabletOrientation }
> = {
  [TabletDeviceType.FOS]: {
    size: TabletSize.TEN_INCH,
    orientation: TabletOrientation.LANDSCAPE,
  },
  [TabletDeviceType.KH]: {
    size: TabletSize.EIGHT_INCH,
    orientation: TabletOrientation.PORTRAIT,
  },
};
